import { useCallback, useMemo } from 'react';

import { useLanguage } from '../../contexts/language';
import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// The questionnaires a clinician can assign, with their titles and
// descriptions in the interface language. data is undefined until the
// answer arrives or when it failed; error and retry are useLoad's.
export function useInstruments() {
  const graphql = useGraphql();
  const { language } = useLanguage();

  const read = useCallback(function() {
    return graphql({
      document: `query Instruments($language: String!) {
        instruments { code version name title(language: $language) description(language: $language) languages }
      }`,
      variables: { language }
    }).then(function(data) {
      return data.instruments;
    });
  }, [ graphql, language ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { instruments: data, error, retry };
  }, [ data, error, retry ]);
}
